export default __webpack_public_path__ + "static/media/paperPlane.dda6d72a.png";